<template src="../templates/normal_fcont_117.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import CreativePrint from '../components/CreativePrint'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import CreatorProfilePepal from '../components/CreatorProfilePepal'
import AppDownloadCreative from '../components/AppDownloadCreative';

import { Carousel,Slide } from 'uiv'


export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,CreatorProfilePepal,CreativePrint,AppDownloadCreative
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
 
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['117-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['117-2']}
    ]};

  }
  
};
</script>
<style >

</style>

